export const CLIENT_ID = "vidmobileconsoleweb";

export const CLIENT_SECRET = "v8h3dp4ks2whs5";

export const VID_CHAIN_MORE_INFO_URL = "https://validatedid.com/en/identity/tutorialcentralized";
export const ES_VID_CHAIN_MORE_INFO_URL = "https://validatedid.com/es/identity/tutorialcentralized";